import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-viber-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/viber-template/"
      channelLabel="Viber"
      namePlaceholder="Enter viber name"
      emptyMessage="No viber found!"
      heartbeatType="viber"
      [guardByProcessing]="false"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks" />
  `
})
export class ViberTemplateComponent {
  protected readonly templateType = TypeEnum.VIBER;

  protected readonly defaultBlocks: { name: string; variables: Record<string, string> }[] = [
    {
      name: 'viber',
      variables: { text: '', image_url: '', cta_text: '', cta_link: '' },
    },
  ];
}
